import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

// Get Organization
export const ListOrganization = createAsyncThunk(
  'organization-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/organization/list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create Organization
export const createOrganization = createAsyncThunk(
  'organization-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/organization/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Organization id
export const editOrganization = createAsyncThunk(
  'organization-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/organization/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete Organization
export const deleteOrganization = createAsyncThunk(
  'organization-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/organization/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// view Organization
export const viewOrganization = createAsyncThunk(
  'organization-view',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/organization/view/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Currency
export const ListCurrency = createAsyncThunk('currency-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/currency/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Currency
export const createCurrency = createAsyncThunk('currency-create', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/currency/store', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Currency id
export const editCurrency = createAsyncThunk('currency-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/currency/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete Currency
export const deleteCurrency = createAsyncThunk('currency-delete', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/currency/destroy/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get StudentList
export const ListStudent = createAsyncThunk('student-list', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student-invoice/get-students`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get StudentList
export const GetStudentDetails = createAsyncThunk(
  'student-details',
  async ({id, type}: {id: string; type: string}, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student-invoice/get-student-details/${id}/${type}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetStdProgram = createAsyncThunk('student-program', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student-invoice/get-std-program/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create createStudentInvoice
export const createStudentInvoice = createAsyncThunk(
  'student-invoice-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/student-invoice/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get ListStudentInvoice
export const ListStudentInvoice = createAsyncThunk(
  'student-invoice-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/student-invoice/list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete deleteStudentInvoice
export const deleteStudentInvoice = createAsyncThunk(
  'student-invoice-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/student-invoice/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get StudentInvoiceDetails
export const studentInvoiceDetails = createAsyncThunk(
  'student-invoice-details',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student-invoice/view/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editStudentInvoiceInvoice = createAsyncThunk(
  'recurring-frequency-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student-invoice/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

//  getPayments
export const GetPayments = createAsyncThunk('get-payments', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student-invoice/get-payments/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create CreateStudentInvoicePayment
export const CreateStudentInvoicePayment = createAsyncThunk(
  'student-invoice-payment-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/student-invoice/store-payment', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// PrintApplicationLetter
export const PrintStudentInvoice = createAsyncThunk(
  'print-student-invoice',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/student-invoice/print/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// email StudentInvoice
export const emailStudentInvoice = createAsyncThunk(
  'student-invoice-email',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post(`/api/student-invoice/email-invoice`, data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const InvoiceSummary = createAsyncThunk('invoice-summary', async (id: any, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student-invoice/invoice-summary/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const changeInstallmentDate = createAsyncThunk(
  'change-installment-date',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/student-invoice/change-installment-date', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PaymentDelete = createAsyncThunk('payment-delete', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student-invoice/delete-payment/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StdInvoices = createAsyncThunk('std-invoice', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student-invoice/std-invoices/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const OrgInvoiceCreate = createAsyncThunk(
  'org-invoice-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/org-invoice/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OrgInvoiceList = createAsyncThunk('org-invoice-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/org-invoice/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const OrgInvoices = createAsyncThunk('org-invoices', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/org-invoice/org-invoices/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const OrgInvoiceInvoiceEdit = createAsyncThunk(
  'org-invoice-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/org-invoice/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OrgInvoiceDelete = createAsyncThunk(
  'org-invoice-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/org-invoice/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OrgInvoiceDetails = createAsyncThunk(
  'org-invoice-details',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/org-invoice/view/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OrgChangeInstallmentDate = createAsyncThunk(
  'org-change-installment-date',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/org-invoice/change-installment-date', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetOrgPayments = createAsyncThunk('get-org-payments', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/org-invoice/get-payments/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const OrgInvoicePaymentCreate = createAsyncThunk(
  'org-invoice-payment-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/org-invoice/store-payment', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OrgInvoicePrint = createAsyncThunk(
  'print-org-invoice',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/org-invoice/print/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OrgPaymentDelete = createAsyncThunk(
  'org-payment-delete',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/org-invoice/delete-payment/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const EmailOrgInvoice = createAsyncThunk(
  'org-invoice-email',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/org-invoice/email/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OrgInvoiceSummary = createAsyncThunk('org-invoice-summary', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/org-invoice/invoice-summary`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetInvDetails = createAsyncThunk('get-inv-details', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/student-invoice/get-inv-details/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const InvoiceUpdate = createAsyncThunk('invoice-update', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/student-invoice/update-invoice', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetInvOrgDetails = createAsyncThunk(
  'get-org-inv-details',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/org-invoice/get-inv-details/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const InvoiceOrgUpdate = createAsyncThunk(
  'invoice-org-update',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/org-invoice/update-invoice', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PaymentGraph = createAsyncThunk('payment-graph', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/student-invoice/payment-dashboard', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const InvSumDetails = createAsyncThunk(
  'summary-details',
  async ({type, academicYear}: {type: string; academicYear: string}, thunkAPI) => {
    try {
      const response = await axios.get(
        `/api/student-invoice/summary-details/${type}/${academicYear}`
      )
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const InvSumDetailsPrint = createAsyncThunk(
  'summary-print',
  async ({type, academicYear}: {type: string; academicYear: string}, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student-invoice/summary-print/${type}/${academicYear}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const SummaryExcel = createAsyncThunk(
  'summary-excel',
  async ({type, academicYear}: {type: string; academicYear: string}) => {
    const response = await axios.get(`/api/student-invoice/summary-excel/${type}/${academicYear}`, {
      responseType: 'blob',
    })

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = 'StudentPayments.xlsx'
    document.body.appendChild(link)
    link.click()

    link.remove()
    window.URL.revokeObjectURL(url)
  }
)

export const MonthlyReport = createAsyncThunk(
  'std-inv-monthly-report',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/student-invoice/monthly-reports', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const MonthlyReportPrint = createAsyncThunk(
  'monthly-report-print',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/student-invoice/monthly-report-print', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const MonthlyReportExcel = createAsyncThunk(
  'monthly-report-excel',
  async (formData: FormData) => {
    const response = await axios.post('/api/student-invoice/monthly-report-excel', formData, {
      responseType: 'blob',
    })

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = 'StudentPayments.xlsx'
    document.body.appendChild(link)
    link.click()

    link.remove()
    window.URL.revokeObjectURL(url)
  }
)

export const SendCustomReminder = createAsyncThunk(
  'send-custom-reminder',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`/api/student-invoice/send-custom-reminder`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DestroyNotification = createAsyncThunk(
  'destroy-notification',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student-invoice/destroy-notification/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type FinanceState = {
  record: any
  records: any
  errors: any
}

const initialState: FinanceState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const financeSlice = createSlice({
  name: 'finance',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListOrganization.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(ListCurrency.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createCurrency.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(createStudentInvoice.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListStudentInvoice.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
  },
})

export const {reset} = financeSlice.actions
export default financeSlice.reducer
